export abstract class IndexedService<TX = unknown> {
  abstract createTransaction(storeName: string): Promise<TX>;
  abstract exists(storeName: string, key: any, transaction?: TX): Promise<boolean>;
  abstract getByKey<T>(storeName: string, key: any, transaction?: TX): Promise<T>;
  abstract getAllFromIndex<T>(storeName: string, indexName: string, key: any, transaction?: TX): Promise<T[]>;
  abstract getAll<T>(storeName: string, transaction?: TX): Promise<T[]>;
  abstract deleteAllFromIndex(stores: string[], indexName: string, key: any, transaction?: TX): Promise<void>;
  abstract add(storeName: string, entry: unknown, transaction?: TX): Promise<void>;
  abstract delete(storeName: string, key: any, transaction?: TX): Promise<void>;
  abstract deleteAll(storeName: string, keys: any[], transaction?: TX): Promise<void>;
  abstract update(storeName: string, entry: unknown, transaction?: TX): Promise<void>;
  abstract exportJson(): Promise<Record<string, string>>;
  abstract waitAllDone(): Promise<void>;
  abstract addAll(store: string, entries: any[], transaction?: TX): Promise<void>;
  abstract updateAll(store: string, entries: any[], transaction?: TX): Promise<void>;
  abstract clear(): Promise<void>;
}
